export default __webpack_public_path__ + "static/lframe-debt-con-v2-7067fd135c14d3210f72c120abc5fbc7.webp";